import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import ReactSVG from 'react-svg'

export const SendRequestButton = ({ onClick, title, isDisabled }) => {
  const { t } = useTranslation('common')

  return (
    <button
      id='vehicle-part-request-submit'
      className={`vehicle-part-request-submit`}
      onClick={onClick}
      disabled={isDisabled}
    >
      <ReactSVG src='/icons/cart.svg' wrapper='span' beforeInjection={svg => {
        svg.setAttribute('style', 'margin-right: 10px; width: 30px; height: 27px;')
        svg.querySelectorAll('path').forEach(path => {
          path.setAttribute('fill', '#fff')
        })
      }} />
      <p>{title}</p>
    </button>
  )
}
